import moment from "moment";
import {v4 as uuidv4} from "uuid";
import {getCurrentEpochTimeInSeconds, responseErrorHandler} from "../libs.jsx";
import {getAuthHeaders} from "../services/auth";
import {getSession, setSession} from "../services/session";


// Response ErrorCode 10 is always a 500 return code from backend
// Response ErrorCode 11 is always a 503 connection timeout or service unavailable
// Response ErrorCode 12 is always a 403 Forbidden unauthorized connection


async function PackageRequest(payload, method="POST"){
    const headers = await getAuthHeaders();
    if (method.toString().toLowerCase() === "get"){
        return {
            method: method,
            headers: headers
        };
    }else{
        return {
            method: method,
            headers: headers,
            body: JSON.stringify(payload)
        };
    }
}

async function PackageRequestCustom(payload, method="POST", custHeader, custValue){
    if (custHeader?.toLowerCase() === "authorization"){
        return {
            method: method,
            headers: {'Content-Type': 'application/json', Authorization: custValue},
            body: JSON.stringify(payload)
        }
    }else if (custValue){
        const headers = await getAuthHeaders();
        return {
            method: method,
            headers: {...headers, 'x-custom-token': custValue},
            body: JSON.stringify(payload)
        }
    }else{
        return {
            method: method,
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(payload)
        }
    }
}

function ProcessSessionReload(resp, keyType, itemId, campusOverride){
    if (resp?.Status === "OK") {
        let dData = getSession();
        if (dData){
            if (keyType === "corporate_id" && itemId){
                dData.corp = parseInt(itemId);
            }
            dData.acntList = resp?.CampusList;
            dData.acnt = campusOverride && campusOverride !== 0 ? campusOverride : resp?.CampusId;
            dData.campus = resp?.CampusName;
            if (keyType === "corporate_id") {
                dData.corporateName = resp?.CampusName || dData.corporateName;
            }
            dData.campusData = resp?.CampusData;
            dData.checkin = resp?.Checkin ? resp.Checkin : 0;
            dData.rounds = resp?.Rounds ? resp.Rounds : 0;
            dData.evmSiteId = resp?.evmSiteId ? resp.evmSiteId : "0";
            dData.resMobile = resp?.ResidentApp ? resp.ResidentApp : 0;
            dData.cloud = resp?.is_cloud ? resp.is_cloud : 0;
            dData.userrole = resp.UserRole;
            dData.role_id = resp?.RoleId ? resp.RoleId : 0;
            if (dData?.corp && dData?.myCorp?.toString() !== dData?.corp?.toString()){
                dData.my_role_weight = resp?.RoleWeight ? resp.RoleWeight : 10;
                dData.my_role_name = resp?.RoleName ? resp.RoleName : "Caregiver";
            }else{
                dData.my_role_weight = resp?.RoleWeight ? resp.RoleWeight : 10;
                dData.my_role_name = resp?.RoleName ? resp.RoleName : "Caregiver";
                dData.role_weight = resp?.RoleWeight ? resp.RoleWeight : 10;
                dData.role_name = resp?.RoleName ? resp.RoleName : "Caregiver";
            }
            dData.access = resp.PortalAccess;
            dData.groups = resp?.GroupIds ? resp.GroupIds : [];
            dData.groupGuids = resp?.GroupGuids ? resp.GroupGuids : [];
            dData.displayEdit = resp.UserEditDisplayName;
            dData.groupEdit = resp.CaregiverChgGroupEnabled;
            dData.hybrid = resp?.is_hybrid ? resp.is_hybrid : false;
            dData.legacy = resp?.show_legacy ? resp.show_legacy : false;
            dData.new = resp?.show_new ? resp.show_new : false;
            dData.myVersion = resp?.portal_version ? resp.portal_version : "";
            dData.serverVersion = resp?.server_version ? resp.server_version : "";
            dData.newestVersion = resp?.latest_version ? resp.latest_version : "";
            dData.event_notes_active = resp?.event_notes_active ? resp.event_notes_active : false;
            dData.event_notes_preform = resp?.event_notes_preform ? resp.event_notes_preform : false;
            dData.event_notes_freeform = resp?.event_notes_freeform ? resp.event_notes_freeform : false;
            dData.is_reason_editable = resp?.is_reason_editable ? resp.is_reason_editable : false;
            dData.notice_message = resp?.notice_message ? resp.notice_message : "";
            setSession(dData);
            return [true];
        } else {
            return [false];
        }
    } else {
        return [false];
    }
}

export function ProcessLogin(resp, payload, props){
    if (resp !== undefined && resp?.Status === "Ok" && (resp?.Plan || ["palcare", "palcare-admin"].includes(resp?.UserRole))) {
        const prePack = {
            user: resp?.UserId ? resp.UserId : "",
            slauth: true,
            end: null,
            tKey: "managed-by-amplify",
            acntList: resp?.CampusList ? resp.CampusList : resp.CampusId,
            acnt: resp?.CampusId[0] ? resp.CampusId[0] : 0,
            myAcnt: resp?.CampusId[0] ? resp.CampusId[0] : 0,
            corp: resp?.CorpId ? resp.CorpId : 0,
            myCorp: resp?.CorpId ? resp.CorpId : 0,
            display: resp?.DisplayName ? resp.DisplayName : "",
            email: resp?.Email ? resp.Email : "",
            username: payload?.Username ? payload.Username : "",
            campus: resp?.CampusName ? resp.CampusName : "",
            corporateName: resp?.CampusName ? resp.CampusName : "",
            campusData: resp?.CampusData ? resp.CampusData : {},
            userrole: resp?.UserRole ? resp.UserRole : "",
            role_id: resp?.RoleId ? resp.RoleId : 0,
            role_weight: resp?.RoleWeight ? resp.RoleWeight : 10,
            my_role_weight: resp?.RoleWeight ? resp.RoleWeight : 10,
            role_name: resp?.RoleName ? resp.RoleName : "Caregiver",
            access: resp?.PortalAccess ? resp.PortalAccess : {},
            perPage: 100,
            areaFilter: [],
            areaGroupFilter: [],
            areaTypeFilter: [],
            devFilter: [],
            devCatFilter: [],
            resFilter: [],
            residentGroupFilter: [],
            typeFilter: [],
            userFilter: [],
            responseFilter: [false, "lt", 60],
            userGroupFilter: [],
            reasonFilter: [],
            areaFilterLabel: [],
            areaGroupFilterLabel: [],
            areaTypeFilterLabel: [],
            devFilterLabel: [],
            devCatFilterLabel: [],
            resFilterLabel: [],
            residentGroupFilterLabel: [],
            typeFilterLabel: [],
            userFilterLabel: [],
            userGroupFilterLabel: [],
            reasonFilterLabel: [],
            responseFilterLabel: ["Response time", "less than", "60 minutes"],
            dashboard: {
                main: {
                    areaTypeFilter: []
                },
                corp: {
                    areaTypeFilter: [],
                    areaTypeFilterLabel: [],
                    devCatFilter: [],
                    devCatFilterLabel: [],
                    responseFilter: [false, "lt", 60],
                    responseFilterLabel: ["Response time", "less than", "60 minutes"]
                }
            },
            groups: resp?.GroupIds ? resp.GroupIds : [],
            groupGuids: resp?.GroupGuids ? resp.GroupGuids : [],
            displayEdit: resp.UserEditDisplayName,
            groupEdit: resp.CaregiverChgGroupEnabled,
            serverDefault: resp.ServerMac,
            sessionId: "S"+uuidv4().toString(),
            migrated: resp?.Migrated ? resp.Migrated : false,
            cognito: resp?.CognitoId,
            checkin: resp?.Checkin ? resp.Checkin : 0,
            rounds: resp?.Rounds ? resp.Rounds : 0,
            evmSiteId: resp?.evmSiteId ? resp.evmSiteId : "0",
            resMobile: resp?.ResidentApp ? resp.ResidentApp : 0,
            cloud: resp?.is_cloud ? resp.is_cloud : false,
            soundsOff: false,
            reloadTime: parseInt(getCurrentEpochTimeInSeconds()) + 300,
            hybrid: resp?.is_hybrid ? resp.is_hybrid : false,
            legacy: resp?.show_legacy ? resp.show_legacy : false,
            new: resp?.show_new ? resp.show_new : false,
            myVersion: resp?.portal_version ? resp.portal_version : "",
            serverVersion: resp?.server_version ? resp.server_version : "",
            newestVersion: resp?.latest_version ? resp.latest_version : "",
            event_notes_active: resp?.event_notes_active ? resp.event_notes_active : false,
            event_notes_preform: resp?.event_notes_preform ? resp.event_notes_preform : false,
            event_notes_freeform: resp?.event_notes_freeform ? resp.event_notes_freeform : false,
            is_reason_editable: resp?.is_reason_editable ? resp.is_reason_editable : false,
            ehr_popup: resp?.ehr_popup ? resp.ehr_popup : false,
            notice_message: resp?.notice_message ? resp.notice_message : ""
        };
        setSession(prePack);
        window.location.reload(true);
    } else {
        console.log(resp)
        if (resp !== undefined && resp?.Status === "Ok" && !resp?.Plan){
            props.setMsg.setForm(prevState => {
                return {...prevState, errMsg: "Service plan has expired, please contact billing to resolve.",
                    attempts: props.attempts + 1}
            });
        }else{
            props.setMsg.setForm(prevState => {
                return {...prevState, errMsg: "Account not authorized. Please contact your administrator.",
                    attempts: props.attempts + 1}
            });
        }
        document.getElementById("loadSubmit").classList.add("d-none");
        document.getElementById("subBtn").classList.remove("d-none");
    }
}

function DataTranslationReturn(resp){
    if (resp?.Status?.toLowerCase() === "ok"){
        return [true, resp?.Content, ""];
    }else{
        return [false, resp?.Content, resp?.ErrorCode];
    }
}

function ProcessData(resp){
    if (Array.isArray(resp) === true) {
        if (getSession() !== null){
            return resp;
        } else {
            return undefined;
        }
    } else {
        return undefined;
    }
}


function UserReturn(resp){
    if (resp?.Status?.toLowerCase() === "ok") {
        return [true];
    }
    else{
        return [false, resp?.ErrorCode];
    }
}

function postReturn(resp){
    if (resp?.Status === "OK"){
        return [true, ""];
    }else{
        return [false, resp?.ErrorCode];
    }
}

function SaveReturn(resp){
    if (resp?.Status === "OK"){
        return [true];
    }
    else if (resp?.Status === "Invalid"){
        return [false, "Forbidden, user not authorized."];
    }
    else if (resp?.Status === "1"){
        return [false, `Error encountered, ${resp?.Fail} failed. Please contact your customer success manager for assistance.`];
    }
    else if (resp?.Status === "2"){
        return [false, `Internal server error, ${resp?.Fail} failed. Please contact your customer success manager for assistance.`];
    }
    else{
        if (resp?.ErrorCode === "9"){
            return [false, "Server already exists, server may be removed or migrated from the Admin Panel."];
        }else{
            return [false, "Unknown failure, request not processed."];
        }
    }
}


function ProcessReportData(resp){
    if (resp?.Status?.toLowerCase() === "ok") {
        if (getSession() !== null){
            return resp.Res;
        } else {
            return {};
        }
    } else {
        if (resp?.Status?.toLowerCase() === "error"){
            return resp.Res;
        }
        return {};
    }
}


function ProcessGetReturn(resp){
    if (resp?.Status !== "Error" && resp?.Content?.length > 0){
        if (getSession() !== null){
            return resp.Content[0];
        } else {
            return [];
        }
    }
    else{
        if (resp?.Status === "Error") {
            console.log("Error Code: ", resp.ErrorCode);
        }
        return [];
    }
}


function ProcessQueryReturnV2(resp){
    if (resp?.Status !== "Error" && resp?.Content?.length > 0){
        if (getSession() !== null){
            return resp.Content;
        } else {
            return [];
        }
    }
    else{
        return [];
    }
}

function ProcessReturnMinimum(resp){
    if (resp?.Status !== "Error" && resp?.Content){
        if (getSession() !== null){
            return resp.Content;
        } else {
            return [];
        }
    }
    else{
        return [];
    }
}


function ProcessQueryReturn(resp, table){
    if (resp?.Status === "OK") {
        if (getSession() !== null){
            if (table?.toLowerCase() === "user"){
                let dtFormatted;
                for (let i=0; i < resp.Content.length; i++){
                    if (resp?.Content[i].hasOwnProperty("LastLoginTime")){
                        dtFormatted = resp.Content[i].LastLoginTime !== 0 ?
                            moment.utc(resp.Content[i].LastLoginTime*1000).local().format("M/D/YYYY h:mm A") : "- None";
                        resp.Content[i].FormattedLoginTime = dtFormatted.split(" ");
                    }else{
                        resp.Content[i].FormattedLoginTime = ["-", "-", ""];
                    }
                }
            }
            return resp?.Content;
        } else {
            return [];
        }
    } else {
        return [];
    }
}

function ProcessQueryExactReturn(resp){
    if (resp?.Status !== "Error" && resp?.Content?.length > 0) {
        if (getSession() !== null){
            return resp.Content[0];
        } else {
            return {};
        }
    } else {
        return {};
    }
}


function v2SendReturn(resp){
    if (resp?.status === "success"){
        return [true];
    }
    else{
        return [false];
    }
}


function ProcessAlerts(resp){
    if (resp?.Status === "OK"){
        if (getSession() !== null){
            if (resp?.Alarm){
                let ret = [], tmp = {}, edt, pdatearray;
                for(let i=0; i < resp.Alarm.length; i++){
                    if (resp.Alarm[i]?.AcceptDateTime !== undefined && resp.Alarm[i]?.AcceptDateTime !== ""){
                        tmp.AcceptUsername = resp.Alarm[i]?.AcceptUsername;
                    }else{
                        tmp.AcceptUsername = "Not Accepted";
                    }
                    edt = moment.utc(resp.Alarm[i]?.EventDateTime).local().format("M/D/YYYY h:mm A");
                    pdatearray = edt.split(" ");
                    tmp.EventDateTime = resp.Alarm[i]?.EventDateTime;
                    tmp.LocalEventDateTime = edt;
                    tmp.LocalEventDate = pdatearray[0];
                    tmp.LocalEventTime = pdatearray[1] + " " + pdatearray[2];
                    tmp.ElapsedFormatted = resp.Alarm[i]?.ElapsedFormatted;
                    tmp.Elapsed = resp.Alarm[i]?.Elapsed;
                    tmp.Residents = resp.Alarm[i]?.Residents;
                    tmp.ResidentsParsed = resp.Alarm[i]?.ResidentsParsed;
                    tmp.ResidentsObject = resp.Alarm[i]?.ResidentsObject;
                    tmp.DeviceUse = resp.Alarm[i]?.DeviceUse;
                    tmp.DeviceId = resp.Alarm[i]?.DeviceId;
                    tmp.LocationBuilding = resp.Alarm[i]?.LocationBuilding;
                    tmp.LocationName = resp.Alarm[i]?.LocationName;
                    tmp.LocationId = resp.Alarm[i]?.LocationId;
                    tmp.NearName = resp.Alarm[i]?.NearName;
                    tmp.Near = resp.Alarm[i]?.Near;
                    tmp.AcceptDateTime = resp.Alarm[i]?.AcceptDateTime;
                    tmp.LocalAcceptDateTime = moment.utc(resp.Alarm[i]?.AcceptDateTime).local().format("M/D/YYYY h:mm A");
                    tmp.Status = resp.Alarm[i]?.Status;
                    tmp.Presses = resp.Alarm[i]?.Presses;
                    tmp.LocationArea = resp.Alarm[i]?.LocationArea;
                    tmp.AlertType = resp.Alarm[i]?.AlertType;
                    tmp.AlertSubType = resp.Alarm[i]?.AlertSubType;
                    tmp.AlarmId = resp.Alarm[i]?.AlarmId;
                    tmp.MacAddr = resp.Alarm[i].MacAddr;
                    tmp.AckDateTime = resp.Alarm[i].AckDateTime;
                    tmp.SerialNumber = resp.Alarm[i]?.SerialNumber;
                    tmp.GroupIds = resp.Alarm[i]?.GroupIds;
                    tmp.Version = resp.Alarm[i]?.Version ? resp.Alarm[i].Version.toString() : "2.0";
                    ret.push(tmp);
                    tmp = {};
                }
                if (ret.length > 0){
                    return ret;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        } else {
            return [];
        }
    } else {
        return [];
    }
}

async function ApiRequester(props) {
    let payload, requestParam, resp;
    if (props.reqEndpoint === "login"){
        // Login is now handled directly by Amplify signIn() in LoginForm.jsx.
        // This branch is kept as a no-op fallback — it should never be reached.
        console.warn('[ApiRequester] "login" endpoint is deprecated. Use Amplify signIn() directly.');
        return undefined;
    }else if(["perday", "perhour", "perreason", "resp"].includes(props.reqEndpoint)){
        payload = {CampusId: props?.CampusId, RequestDataType: props.reqEndpoint};
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_DMAIN_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return undefined;
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_DMAIN_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return undefined;
            });
        }
        return ProcessData(resp);
    }else if(props.reqEndpoint === "get-alerts"){
        payload = {CampusId: props?.CampusId, ToGet: props?.ToGet, UserId: props?.UserId, Migrated: props?.Migrated,
                    Mode: props?.mode, Hybrid: props?.hybrid, Legacy: props?.legacy, New: props?.new};
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_ALARMS_ENDPOINT, requestParam).then(response => response.json());
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_ALARMS_ENDPOINT, requestParam).then(response => response.json());
        }
        return ProcessAlerts(resp);
    }else if(props.reqEndpoint === "get-alerts-cloud"){
        payload = {
            campus_id: props?.CampusId,
            user_id: props?.UserId,
            mode: props?.Mode
        };
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_ALARMS_CLOUD_ENDPOINT, requestParam).then(response => response.json());
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_ALARMS_CLOUD_ENDPOINT, requestParam).then(response => response.json());
        }
        return ProcessQueryReturn(resp);
    }else if(props.reqEndpoint === "get-report"){
        payload = {CampusId: props?.CampusId, repType: props?.repType, startDate: props?.startDate,
                    endDate: props?.endDate, devices: props?.devices, locations: props?.locations,
                    deviceKey: props?.deviceKey, locationKey: props?.locationKey};
        requestParam = await PackageRequest(payload);
        try{
            if (import.meta.env.VITE_DEVMODE === "true"){
                resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_REPORTS_ENDPOINT, requestParam).then(response => {
                    return responseErrorHandler(response);
                });
            }else{
                resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_REPORTS_ENDPOINT, requestParam).then(response => {
                    return responseErrorHandler(response);
                });
            }
        }catch (e) {
            console.log(`Exception in get report api request: ${e?.toString()}`);
            resp = {"Status": "Error", "ErrorCode": 10, "Res": {}};
        }
        return ProcessReportData(resp);
    }else if(props.reqEndpoint === "get-mysql-report"){
        payload = {
            campus_id: props?.campus_id,
            campus_guid: props?.campus_guid,
            corporation_id: props?.corporation_id,
            rep_type: props?.rep_type,
            start_date: props?.start_date,
            end_date: props?.end_date,
            device_category_filter: props?.device_category_filter,
            area_filter: props?.area_filter,
            area_group_filter: props?.area_group_filter,
            area_type_filter: props?.area_type_filter,
            reason_filter: props?.reason_filter,
            user_filter: props?.user_filter,
            user_group_filter: props?.user_group_filter,
            event_type_filter: props?.event_type_filter,
            event_category_filter: props?.event_category_filter,
            resident_filter: props?.resident_filter,
            resident_group_filter: props?.resident_group_filter,
            resp_filter_items: props?.resp_filter_items,
            device_filter: props?.device_filter,
            excessive_filter: props?.excessive_filter,
            environment_type: props?.environment_type,
            items: props?.items,
            is_cloud: props?.is_cloud,
            status: props?.status,
            trigger: props?.props,
            severity: props?.props,
            username: props?.username
        };
        requestParam = await PackageRequest(payload);
        try{
            if (import.meta.env.VITE_DEVMODE === "true"){
                resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_MY_REPORTS_ENDPOINT, requestParam).then(response => {
                    return responseErrorHandler(response);
                });
            }else{
                resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_MY_REPORTS_ENDPOINT, requestParam).then(response => {
                    return responseErrorHandler(response);
                });
            }
        }catch (e) {
            console.log(`Exception in get report api request: ${e?.toString()}`);
            resp = {"Status": "Error", "ErrorCode": 10, "Res": {}};
        }
        return ProcessReportData(resp);
    }else if(props.reqEndpoint === "user-manage"){
        payload = {
            Content: props?.Payload,
            OldPayload: props?.OldPayload,
            User: props?.User
        }
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_USER_ENDPOINT, requestParam).then(response => response.json());
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_USER_ENDPOINT, requestParam).then(response => response.json());
        }
        return UserReturn(resp);
    }else if(props.reqEndpoint === "user-manage-2"){
        payload = {
            Payload: props?.Payload,
            client_id: props?.ClientId,
            User: props?.User
        }
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_USER_V2_ENDPOINT, requestParam).then(response => response.json());
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_USER_V2_ENDPOINT, requestParam).then(response => response.json());
        }
        return UserReturn(resp);
    }else if(props.reqEndpoint === "v2Send"){
        /// Endpoint package
        requestParam = await PackageRequest(props.Payload, props.Method);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_DEMO_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_DEMO_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false];
            });
        }
        return v2SendReturn(resp);
    }else if(props.reqEndpoint === "v4emergency"){
        /// Endpoint package
        requestParam = await PackageRequest(props.Payload, props.Method);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_EVENT_E_ENDPOINT+`/${props?.Action}`, requestParam).then(response => response.json()).catch(() => {
                return [false];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_EVENT_E_ENDPOINT+`/${props?.Action}`, requestParam).then(response => response.json()).catch(() => {
                return [false];
            });
        }
        return SaveReturn(resp);
    }else if(props.reqEndpoint === "v4nonemergency"){
        /// Endpoint package
        requestParam = await PackageRequest(props.Payload, props.Method);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_EVENT_NE_ENDPOINT+`/${props?.Action}`, requestParam).then(response => response.json()).catch(() => {
                return [false];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_EVENT_NE_ENDPOINT+`/${props?.Action}`, requestParam).then(response => response.json()).catch(() => {
                return [false];
            });
        }
        return SaveReturn(resp);
    }else if(props.reqEndpoint === "remotecommand") {
        /// Endpoint package
        payload = {
            source: props?.source,
            campus_id: props?.CampusId,
            user_id: props?.User,
            payload: props?.payload,
            client_id: props?.ClientId
        }
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true") {
            resp = await fetch(import.meta.env.VITE_DEVAPI + import.meta.env.VITE_REMOTE_COMMAND_ENDPOINT, requestParam).then(response => response).catch(() => {
                return [false];
            });
        } else {
            resp = await fetch(import.meta.env.VITE_API + import.meta.env.VITE_REMOTE_COMMAND_ENDPOINT, requestParam).then(response => response).catch(() => {
                return [false];
            });
        }
        return resp?.status === 200;
    }else if(props.reqEndpoint === "save"){
        // Main Save endpoint for all tables, allows updates by primary and foreign keys, prelude to addRec use.
        payload = {
            Table: props.Tbl,
            PartitionKey: props?.PKey,
            Content: props?.Payload,
            SortKey: props?.SKey,
            CampusId: props?.CampusId,
            Overwrite: props?.Overwrite
        }
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_POST_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_POST_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }
        return SaveReturn(resp);
    }else if(props.reqEndpoint === "mysave"){
        // Main Save endpoint for all tables, allows updates by primary and foreign keys, prelude to addRec use.
        payload = {
            Table: props.Tbl,
            Content: props?.Payload,
            OldContent: props?.OldPayload,
            pKey: props?.PKey,
            pVal: props?.PVal,
            Condition: props?.Condition,
            CampusId: props?.CampusId,
            ClientId: props?.ClientId,
            User: props?.User
        }
        requestParam = await PackageRequest(payload, props.urlType);
        try{
            if (import.meta.env.VITE_DEVMODE === "true"){
                resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_REST_ENDPOINT, requestParam).then(response => {
                    return responseErrorHandler(response);
                })
            }else{
                resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_REST_ENDPOINT, requestParam).then(response => {
                    return responseErrorHandler(response);
                })
            }
        }catch (e) {
            console.log(`Exception in save rest api call: ${e.toString()}`);
            resp = {"Status": "Error", "ErrorCode": 10, "Content": [], "Success": 0, "Fail": 0}
        }
        return SaveReturn(resp);
    }else if(props.reqEndpoint === "myfetch"){
        // Main request endpoint for all tables, allows fetching by campus id and advanced custom searches.
        payload = {
            pKey: props?.pKey,
            pVal: props?.pVal,
            Procedure: props?.procedure,
            RequestType: props?.reqType,
            Days: props?.Days,
            Table: props?.Tbl,
            Param: props?.param,
            Payload: props?.payload,
            "read-only": props?.["read-only"]
        }
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_FETCH_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_FETCH_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }
        return ProcessQueryReturn(resp);
    }else if(props.reqEndpoint === "mytransaction"){
        // Used for saves with complex multi stored procedure with lambda processing aid to achieve results.
        payload = {
            RequestType: props?.TransType,
            Content: props?.Payload,
            OldContent: props?.OldPayload,
            CampusId: props?.CampusId,
            ClientId: props?.ClientId,
            Param: props?.Param,
            User: props?.User
        }
        requestParam = await PackageRequest(payload, props.urlType);
        try{
            if (import.meta.env.VITE_DEVMODE === "true"){
                resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_TRANS_ENDPOINT, requestParam).then(response => {
                    return responseErrorHandler(response);
                })
            }else{
                resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_TRANS_ENDPOINT, requestParam).then(response => {
                    return responseErrorHandler(response);
                })
            }
        }catch (e) {
            console.log(`Exception in transaction rest api call: ${e.toString()}`);
            resp = {"Status": "Error", "ErrorCode": 10, "Content": [], "Success": 0, "Fail": 0}
        }
        return SaveReturn(resp);
    }else if(props.reqEndpoint === "int-onboarding"){
        payload = {
            action: props?.action,
            campus_id: props?.campus_id,
            client_id: props?.client_id,
            data_type: props?.data_type,
            vendor_id: props?.vendor_id,
            s3_bucket: "palcare-ehr-exports" + (import.meta.env.VITE_DEVMODE === "true" ? "-dev" : "-prod"),
            s3_key_prefix: props?.s3_key_prefix,
            async_processing: props?.async,
            file_id: props?.file_id,
            corporate_id: props?.corporate_id,
            user_id: props?.user_id
        }
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_INT_ONBOARD_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_INT_ONBOARD_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }
        return ProcessQueryReturn(resp)
    }else if(props.reqEndpoint === "int-onboard-upload"){
        payload = {
            action: props?.action,
            campus_id: props?.campus_id,
            onboarding_type: props?.type,
            data_type: props?.data_type,
            vendor_id: props?.vendor_id,
            async_processing: props?.async,
            upload_id: props?.upload_id,
            s3_bucket: props?.s3_bucket,
            s3_key: props?.s3_key,
            corporate_id: props?.corporate_id,
            user_id: props?.user_id
        }
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_INT_UPLOAD_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_INT_UPLOAD_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }
        return resp;
    }else if(props.reqEndpoint === "mqtt"){
        // Main Save endpoint for all tables, allows updates by primary and foreign keys, prelude to addRec use.
        payload = {
            Operation: props.Operation,
            ClientId: props?.ClientId,
            ServerId: props?.ServerId,
            CampusId: props?.CampusId,
            Content: props?.Payload,
            ProductType: props?.ProductType,
            MsgClass: props?.MsgClass
        }
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_POST_MQTT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_POST_MQTT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }
        return postReturn(resp);
    }else if(props.reqEndpoint === "uploadprocess"){
        // Used for saves with complex multi stored procedure with lambda processing aid to achieve results.
        payload = {
            Content: props?.Payload,
            CampusId: props?.CampusId,
            ClientId: props?.ClientId,
            Process: props?.Process,
            User: props?.User
        }
        requestParam = await PackageRequest(payload);
        try{
            if (import.meta.env.VITE_DEVMODE === "true"){
                resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_UPLOAD_ENDPOINT, requestParam).then(response => {
                    return responseErrorHandler(response);
                })
            }else{
                resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_UPLOAD_ENDPOINT, requestParam).then(response => {
                    return responseErrorHandler(response);
                })
            }
        }catch (e) {
            console.log(`Exception in upload process api call: ${e.toString()}`);
            resp = {"Status": "Error", "ErrorCode": 10, "Content": [], "Success": 0, "Fail": 0}
        }
        return ProcessReturnMinimum(resp);
    }else if(props.reqEndpoint === "user-upload"){
        // Used for saves with complex multi stored procedure with lambda processing aid to achieve results.
        payload = {
            Payload: props?.Payload,
            CampusId: props?.CampusId,
            ClientId: props?.ClientId,
            Process: props?.Process,
            User: props?.User
        }
        requestParam = await PackageRequest(payload);
        try{
            if (import.meta.env.VITE_DEVMODE === "true"){
                resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_USER_UPLOAD_ENDPOINT, requestParam).then(response => {
                    return responseErrorHandler(response);
                })
            }else{
                resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_USER_UPLOAD_ENDPOINT, requestParam).then(response => {
                    return responseErrorHandler(response);
                })
            }
        }catch (e) {
            console.log(`Exception in upload process api call: ${e.toString()}`);
            resp = {"Status": "Error", "ErrorCode": 10, "Content": [], "Success": 0, "Fail": 0}
        }
        return DataTranslationReturn(resp);
    }else if(props.reqEndpoint === "getitem"){
        requestParam = await PackageRequest(props.Payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_GET_ITEM, requestParam).then(response => response.json()).catch(() => {
                return {};
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_GET_ITEM, requestParam).then(response => response.json()).catch(() => {
                return {};
            });
        }
        return ProcessQueryExactReturn(resp);
    }else if(props.reqEndpoint === "getitems"){
        payload = {Table: props?.Table, PartitionKey: props?.PKey, PartitionValue: props?.PVal, Projection: props?.Projection,
                    SecondIndex: props?.SecondIndex, CampusId: props?.CampusId, Search: props?.Search ? props.Search : "",
                    IncludeDeleted: props?.IncludeDeleted};
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_QUERY_GET, requestParam).then(response => response.json()).catch(() => {
                return [];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_QUERY_GET, requestParam).then(response => response.json()).catch(() => {
                return [];
            });
        }
        return ProcessQueryReturn(resp, props?.Table);
    }else if(props.reqEndpoint === "getall"){
        payload = {Table: props?.Table, Search: props?.Search, CampusId: props?.CampusId,
            Projection: props?.Projection};
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_GET_ALL, requestParam).then(response => response.json());
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_GET_ALL, requestParam).then(response => response.json());
        }
        return ProcessGetReturn(resp);
    }else if(props.reqEndpoint === "redget"){
        payload = {
            Table: props?.Table ? props.Table : "",
            Column: props?.Column ? props.Column : "",
            getType: props?.GetType ? props.GetType : "",
            Search: props?.Search ? props.Search : "",
            SearchKey: props?.SearchKey ? props.SearchKey : "",
            StartValue: props?.StartValue ? props.StartValue : "",
            EndValue: props?.EndValue ? props.EndValue : "",
            Selector: props?.Selector ? props.Selector : "",
            SelectorValue: props?.SelectorValue ? props.SelectorValue : "",
            SortColumn: props?.SortColumn ? props.SortColumn : "",
            SortOrder: props?.SortOrder ? props.SortOrder : "",
            CampusId: props?.CampusId
        };
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_RED_QUERY, requestParam).then(response => response.json()).catch(() => {
                return [];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_RED_QUERY, requestParam).then(response => response.json()).catch(() => {
                return [];
            });
        }
        return ProcessQueryReturnV2(resp);
    }else if(props.reqEndpoint === "send_report"){
        // Main Save endpoint for all tables, allows updates by primary and foreign keys, prelude to addRec use.
        payload = {
            Content: props?.Payload,
            CampusId: props?.CampusId,
            ClientId: props?.ClientId
        }
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            if (props?.nowait){
                fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_SEND_REPORT, requestParam)
                return [true]
            }else{
                resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_SEND_REPORT, requestParam).then(response => response.json()).catch(() => {
                    return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
                });
            }
        }else{
            if (props?.nowait){
                fetch(import.meta.env.VITE_API+import.meta.env.VITE_SEND_REPORT, requestParam)
                return [true]
            }else{
                resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_SEND_REPORT, requestParam).then(response => response.json()).catch(() => {
                    return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
                });
            }
        }
        return SaveReturn(resp);
    }else if(props.reqEndpoint === "custom"){
        payload = props?.payload
        requestParam = await PackageRequestCustom(payload, props?.method, props?.headerKey, props?.headerValue);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(props?.url, requestParam).then(response => response.json()).catch(() => {
                return [];
            });
        }else{
            resp = await fetch(props?.url, requestParam).then(response => response.json()).catch(() => {
                return [];
            });
        }
        return ProcessQueryReturnV2(resp);
    }else if(props.reqEndpoint === "sessionLoad"){
        // Main Save endpoint for all tables, allows updates by primary and foreign keys, prelude to addRec use.
        payload = {
            pKey: props?.pKey,
            pVal: props?.pVal,
            myId: props?.myId,
            currentId: props?.campus_override
        }
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_SESSION_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_SESSION_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }
        return ProcessSessionReload(resp, props?.pKey, props?.pVal, props?.campus_override);
    }else if(props.reqEndpoint === "simulate"){
        // Main request endpoint for all tables, allows fetching by campus id and advanced custom searches.
        payload = {
            campus_id: props?.campus_id,
            device_id: props?.device_id,
            timeofday: props?.timeofday,
            event_category_id: props?.event_category_id,
            runtime: props?.runtime
        }
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_SIM_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_SIM_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }
        return ProcessQueryReturn(resp);
    }else if(props.reqEndpoint === "myvalidation"){
        // Main request endpoint for all tables, allows fetching by campus id and advanced custom searches.
        payload = {
            RequestType: props?.reqType,
            Payload: props?.payload
        }
        requestParam = await PackageRequest(payload);
        if (import.meta.env.VITE_DEVMODE === "true"){
            resp = await fetch(import.meta.env.VITE_DEVAPI+import.meta.env.VITE_VALID_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }else{
            resp = await fetch(import.meta.env.VITE_API+import.meta.env.VITE_VALID_ENDPOINT, requestParam).then(response => response.json()).catch(() => {
                return [false, "Request timed out. Please contact your customer success manager for assistance if failure persists."];
            });
        }
        return ProcessQueryReturn(resp);
    }
}

export default ApiRequester;